module.exports = __webpack_public_path__ + "static/media/contact.32cb6558.jpg";